<template>
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
               <a class="link-dark text-truncate d-flex align-items-center gap-2"  >
                  
                  <div>
                    <h2 class="text-white text-center">Laundry Master</h2>
                  </div>
               
               </a>
         
            </div>
         </div>
         <!--start------------------------------------------------------- body----------------------------------------------------------------------------->

         <!-- Body -->
        <div class="container d-flex flex-column  mt-5 align-items-center flex-grow-1">
            <div class="card p-2 shadow" style="width: 100%; max-width: 400px;">
                <h3 class="text-center mb-3">Login</h3>
                
                    <div class="mb-3">
                        <label for="mobile" class="form-label">Mobile No</label>
                        <input type="text" id="mobile" v-model="login.mobile" class="form-control" required>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Password</label>
                        <input type="password" id="password" v-model="login.password" class="form-control" maxlength="10" required>
                    </div>
                    <button class="btn btn-primary w-100" @click="laundrylogin">Login</button> 
                    <div class="text-center mt-3">
                        <p>Not registered?<router-link :to="'/register'">Create an account</router-link></p>
    
                    </div> 
            </div>
        </div>

        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->
 
         <!-- footer -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>
      </div>
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.custom-btn {
    background: linear-gradient(328deg, #ff0000, #000199);
    border: none; /* Remove Bootstrap's default border */
    color: white; /* Ensure text is readable */
}

</style>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
    document.getElementById('global-loader').style.display = 'none';
    const token = localStorage?.getItem("token");
    if(token){
        this.$router.replace('/home');
    }
    
     
},
  data() {
    return {
      loading:false,
      error:null,
      
      login:
           {
             mobile:'',
             password:'',
          
           },


    }
  },
  methods:{
    

      laundrylogin() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("laundrylogin",self.login,{ headers: { "Content-Type": "application/json" }}).then((response) => {
              if(response.data.success==1){
                    localStorage.setItem('token',response.data.token); 
                    self.$router.replace('/home');
                    self.$swal.fire(response.data.message);
              }else if(response.data.success==2){
                    self.$swal.fire({
                      icon: 'error',
                      title: 'Expired!',
                      html: `${response.data.message}<br><br><a href="https://wa.me/${response.data.activate}?text=${encodeURIComponent("Reactivate,My laundry account")}" class="btn btn-primary">Activate</a>`,
                      showConfirmButton: false,
                      allowOutsideClick: false
                    });
              }else 
              self.$swal.fire(response.data.message);
              
              // $sw
          }).then(() => {
            
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 









  }
}
</script>
